export function Channel() {
    return {
        data: {
            code: '',
            unicodes:[
                'english',
                'math'
            ]
        },

        setCode: function (lesson) {
            switch(lesson.channel.code) {
                case 'english': //英语
                case 'chinese': //国际中文
                    this.code = 'chinese';
                    break;
                case 'chinese-zh'://语文
                case 'math'     : //数学
                case 'physics'  : //物理
                case 'chemistry': //化学
                case 'biology'  : //生物
                case 'geography': //地理
                case 'history'  : //历史
                case 'daofa'    : //道德与法治
                    this.code = 'math';
                    break;
                default:
                    this.code = lesson.channel.code;
                    break;
            }
//            this.code = 'english';
        },
        getCode: function () {
            return this.code;
        },

        homeClassName: function () {
            switch (this.code) {
                case 'english': return 'home-english';
                case 'math': return 'home-math';
                default: return 'home-default';
            }
        },

        /** 全局背景图 */
        bgImg: function() {
            switch (this.code) {
                case 'chinese': return require('@/assets/全球说/bg.png');
                case 'english': return require('@/assets/英语界面设计02/系统界面/背景图.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/背景图.png');
                default: return require('@/assets/强国之路界面设计/首页/背景图.png');
            }
        },

        /** 学生状态监控画面style，目前主要是为了指定窗口坐标和尺寸 */
        userCameraViewStyle: function () {
            switch (this.code) {
                case 'math': return {right:'3.3%', top:'13%', height:'19%', width:'19%',
                    backgroundColor:'#000000', padding:'1px', borderRadius:'5px'};
                default: return {right:'0%', top:'9%', width:'9%'};
            }
        },

        /** 进入课程的资源：自动进行按钮图 */
        navEnterLessonAutoImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/进入课程/自动进行.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/进入课程/自动进行.png');
                default: return require('@/assets/强国之路界面设计/进入课程/自动进行.png');
            }
        },
        /** 进入课程的资源：逐节进行按钮图 */
        navEnterLessonStepImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/进入课程/逐节进行.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/进入课程/逐节进行.png');
                default: return require('@/assets/强国之路界面设计/进入课程/逐节进行.png');
            }
        },
        /** 进入课程的资源：公司名称图 */
        navCopyRightImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/进入课程/@北京奇峰天下科技有限公司技术支持.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/进入课程/@北京奇峰天下科技有限公司技术支持.png');
                default: return require('@/assets/强国之路界面设计/进入课程/@北京奇峰天下科技有限公司技术支持.png');
            }
        },

        /** 用户主动提问的资源：问答窗口style */
        userAskViewStyle: function() {
            switch (this.code) {
                case 'math': return {position:'absolute',left:'8%',width:'84%',top:'8%',height:'88%'};
                default: return {position:'absolute',left:'15%',width:'70%',top:'10%',height:'80%'};
            }
        },
        /** 用户主动提问的资源：黑板框背景图 */
        userAskContainerImg: function() {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/黑板框.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/学生提问/黑板框.png');
                default: return require('@/assets/ask2/container.png');
            }
        },
        /** 用户主动提问的资源：logo图 */
        userAskWantToAskImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/学生提问logo.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/学生提问/我想问.png');
                default: return require('@/assets/ask2/wanttoask.png');
            }
        },
        /** 用户主动提问的资源：logo图的style */
        userAskWantToAskImgStyle: function () {
            switch (this.code) {
                case 'english': return {position:'absolute',left:'27%',width:'46%',top:'8%'};
                case 'math': return {position:'absolute',left:'0%',width:'20%',top:'-9.5%'};
                default: return {position:'absolute',left:'10%',width:'15%',top:'8%'};
            }
        },
        /** 用户主动提问的资源：学生输入框的style */
        userAskQaTextStyle: function () {
            switch (this.code) {
                case 'math': return {position:'absolute', left:'7.5%', top:'14%', width:'82%', height:'6%', padding:'5px',
                    borderWidth:'2px', borderStyle:'solid', borderColor:'#8c8c8c', borderRadius:'5px',
                    boxShadow:'rgba(0, 0, 0, 0.9) 0px 0px 3px', fontSize:'1.3vw'};
                default: return {position:'absolute', left:'10%', top:'20%', width:'80%', height:'18%', padding:'5px',
                    borderWidth:'2px', borderStyle:'solid', borderColor:'#d5ebff', borderRadius:'10px',
                    boxShadow:'rgba(0, 0, 255, 0.3) 0px 0px 10px', fontSize:'1.3vw'};
            }
        },
        userAskQaTextStyle2: function () {
            switch (this.code) {
                case 'math': return {position:'absolute', left:'7.5%', top:'14%', width:'78%', height:'6%', padding:'5px',
                    borderWidth:'2px', borderStyle:'solid', borderColor:'#8c8c8c', borderRadius:'5px',
                    boxShadow:'rgba(0, 0, 0, 0.9) 0px 0px 3px', fontSize:'1.3vw'};
                default: return {position:'absolute', left:'10%', top:'20%', width:'80%', height:'18%', padding:'5px',
                    borderWidth:'2px', borderStyle:'solid', borderColor:'#d5ebff', borderRadius:'10px',
                    boxShadow:'rgba(0, 0, 255, 0.3) 0px 0px 10px', fontSize:'1.3vw'};
            }
        },
        /** 用户主动提问的资源：学生输入按钮大小style */
        userAskButtonSize: function () {
            switch (this.code) {
                case 'math': return {width:'10%',height:'80%', margin:'1px'};
                default: return {};
            }
        },
        userAskEnablePhotoButtons: function() {
            switch (this.code) {
                case 'english':
                case 'math':
                    return true;
                default:
                    return false;
            }
        },
        /** 用户主动提问的资源：学生输入框上面的按钮容器的style */
        userAskPhotoButtonContainerStyle: function () {
            switch (this.code) {
                case 'math': return {position:'absolute',left:'7.5%',top:'6%',width:'73.4%',height:'6%'};
                default: return {position:'absolute',left:'10%',top:'2%',width:'82%',height:'7%'};
            }
        },
        /** 用户主动提问的资源：学生输入框下面的按钮容器的style */
        userAskInputButtonContainerStyle: function () {
            switch (this.code) {
                case 'math': return {position:'absolute',left:'7.5%',top:'24%',width:'83.4%',height:'6%'};
                default: return {position:'absolute',left:'10%',top:'43.3%',width:'82%',height:'7%'};
            }
        },
        /** 用户主动提问的资源：教师回复框的style */
        userAskQaAnswerStyle: function () {
            switch (this.code) {
                case 'math': return {position:'absolute',left:'7.5%',top:'31%',width:'82%',height:'18%',padding:'5px',
                    borderWidth:'2px',borderStyle:'solid',borderColor:'#8c8c8c',borderRadius:'5px',
                    boxShadow:'rgba(0, 0, 0, 0.9) 0px 0px 3px', fontSize:'1.3vw'};
                default: return {position:'absolute',left:'10%',top:'52%',width:'80%',height:'32%',padding:'5px',
                    borderWidth:'2px',borderStyle:'solid',borderColor:'#d5ebff',borderRadius:'10px',
                    boxShadow:'rgba(0, 0, 255, 0.3) 0px 0px 10px', fontSize:'1.3vw'};
            }
        },
        /** 用户主动提问的资源：是否显示:老师板书 markdown，和配图 */
        userAskIsShowMarkdownAndImage: function() {
            return this.code === 'math';
        },
        /** 用户主动提问的资源：[老师板书 markdown，和配图]的容器的style */
        userAskReplyMarkdownAndImageContainerStyle: function() {
            switch (this.code) {
                case 'math': return {position:'absolute', left:'7.5%',top:'54%',width:'83.5%',height:'28%'};
                default: return {};
            }
        },
        /** 用户主动提问的资源：老师板书 markdown的style */
        userAskReplyMarkdownStyle: function() {
            switch (this.code) {
                case 'math': return {position:'absolute', left:'0%',top:'0%',width:'60%', height:'100%', backgroundColor:'#e7e7e7',
                    borderWidth:'2px',borderStyle:'solid',borderColor:'#8c8c8c',borderRadius:'5px', fontSize:'1.3vw',
                    boxShadow:'rgba(0, 0, 0, 0.9) 0px 0px 3px'};
                default: return {};
            }
        },
        /** 用户主动提问的资源：老师配图的style */
        userAskReplyImageStyle: function() {
            switch (this.code) {
                case 'math': return {position:'absolute', right:'0%',top:'0%',width:'38%', height:'100%', backgroundColor:'#e7e7e7',
                    borderWidth:'2px',borderStyle:'solid',borderColor:'#8c8c8c',borderRadius:'5px',
                    boxShadow:'rgba(0, 0, 0, 0.9) 0px 0px 3px'};
                default: return {};
            }
        },
        /** 用户主动提问的资源：语音自动确认勾选框-已勾选图片 */
        userAskAutoVoiceImgChecked: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/语音自动确认-选中.png');
                default: return require('@/assets/强国之路界面设计/提问页面/语音自动确认-选中.png');
            }
        },
        /** 用户主动提问的资源：语音自动确认勾选框-未勾选图片 */
        userAskAutoVoiceImgUnchecked: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/语音自动确认.png');
                default: return require('@/assets/强国之路界面设计/提问页面/语音自动确认.png');
            }
        },
        /** 用户主动提问的资源：语音自动确认勾选框-style */
        userAskAutoVoiceImgStyle: function () {
            switch (this.code) {
                case 'english': return {position:'absolute',left:'0%',width:'16%',top:'15%',cursor:'pointer'};
                default: return {position:'absolute',left:'0%',width:'16%',top:'15%',cursor:'pointer'};
            }
        },
        /** 用户主动提问的资源：开始录音按钮图 */
        userAskBtnVoiceInputBgImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/语音输入.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/学生提问/语音输入.png');
                default: return require('@/assets/ask2/btn-vinput0.png');
            }
        },
        /** 用户主动提问的资源：结束录音按钮图 */
        userAskBtnVoiceInputEndBgImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/结束录音.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/学生提问/结束录音.png');
                default: return require('@/assets/ask2/btn-vinput-end0.png');
            }
        },
        /** 用户主动提问的资源：粘贴按钮图 */
        userAskBtnPastePhotoBgImg: function (bEnable) {
            if(bEnable) {
                return require('@/assets/数学课UI-0901/系统界面/学生提问/paste.png');
            } else {
                return require('@/assets/数学课UI-0901/系统界面/学生提问/paste.png');
            }
        },
        /** 用户主动提问的资源：拍照按钮图 */
        userAskBtnTakePhotoBgImg: function (bEnable) {
            if(bEnable) {
                return require('@/assets/数学课UI-0901/系统界面/学生提问/拍照上传.png');
            } else {
                return require('@/assets/数学课UI-0901/系统界面/学生提问/拍照上传-灰色.png');
            }
        },
        /** 用户主动提问的资源：上传图片按钮图 */
        userAskBtnUploadPhotoBgImg: function (bEnable) {
            if(bEnable) {
                return require('@/assets/数学课UI-0901/系统界面/学生提问/本地上传.png');
            } else {
                return require('@/assets/数学课UI-0901/系统界面/学生提问/本地上传-灰色.png');
            }
        },
        /** 用户主动提问的资源：发送答案按钮图 */
        userAskBtnVoiceSendBgImg: function (bEnable) {
            if(bEnable) {
                switch (this.code) {
                    case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/确认输入.png');
                    case 'math': return require('@/assets/数学课UI-0901/系统界面/学生提问/确认输入.png');
                    default: return require('@/assets/ask2/btn-send0.png');
                }
            } else {
                switch (this.code) {
                    case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/确认输入-灰.png');
                    case 'math': return require('@/assets/数学课UI-0901/系统界面/学生提问/确认输入-灰色.png');
                    default: return require('@/assets/ask2/btn-send0-gray.png');
                }
            }
        },
        /** 用户主动提问的资源：选择附图按钮图 fn: 1=选择图片，2=查看，3=移除 */
        userAskBtnChoosePhotoBgImg: function (fn) {
            switch (fn) {
                case 1:
                    switch (this.code) {
                        case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/选择附图.png');
                        case 'math': return require('@/assets/数学课UI-0901/系统界面/学生提问/选择附图.png');
                        default: return require('@/assets/ask2/btn-choose-img.png');
                    }
                case 2:
                    switch (this.code) {
                        case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/查看附图.png');
                        case 'math': return require('@/assets/数学课UI-0901/系统界面/学生提问/查看附图.png');
                        default: return require('@/assets/ask2/btn-view-img.png');
                    }
                case 3:
                default:
                    switch (this.code) {
                        case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/移除附图.png');
                        case 'math': return require('@/assets/数学课UI-0901/系统界面/学生提问/移除附图.png');
                        default: return require('@/assets/ask2/btn-remove-img.png');
                    }
            }
        },
        /** 用户主动提问的资源：结束提问按钮图 */
        userAskBtnVoiceEndBgImg: function(bEnable) {
            if(bEnable) {
                switch (this.code) {
                    case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/结束提问.png');
                    case 'math': return require('@/assets/数学课UI-0901/系统界面/学生提问/结束提问.png');
                    default: return require('@/assets/ask2/btn-end0.png');
                }
            } else {
                switch (this.code) {
                    case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/结束提问-灰.png');
                    case 'math': return require('@/assets/数学课UI-0901/系统界面/学生提问/结束提问-灰色.png');
                    default: return require('@/assets/ask2/btn-end0-gray.png');
                }
            }
        },
        /** 用户主动提问的资源：我要提问头像背景图 */
        userAskTriggerWantToAskImg: function (draftId) {
            if(draftId === 274)
                return require('@/assets/lesson_ui/274_我要提问.png');
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/我要提问.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/学生提问/我要提问.png');
                default: return require('@/assets/强国之路界面设计/AI机器人讲话/我要提问.png');
            }
        },
        /** 用户主动提问的资源：等待回答头像背景图 */
        userAskTriggerWaitingAnswerImg: function (draftId) {
            if(draftId === 274)
                return require('@/assets/lesson_ui/274_我要提问-等待.png');
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/等待回答.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/学生提问/等待回答.png');
                default: return require('@/assets/强国之路界面设计/AI机器人讲话/等待回答.png');
            }
        },



        /** 随堂测试资源：黑板框背景图 */
        userAnsContainerImg: function() {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/学生提问页面/黑板框.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/随堂测试/黑板框.png');
                default: return require('@/assets/强国之路界面设计/随堂测试/黑板框.png');
            }
        },
        /** 随堂测试资源：logo图 */
        userAnsContainerLogo: function() {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/随堂测试/随堂测试logo.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/随堂测试/随堂测试logo.png');
                default: return require('@/assets/强国之路界面设计/随堂测试/随堂测试logo.png');
            }
        },
        /** 随堂测试资源：ABCD四个选项的背景图 */
        userAnsOptionItemBgImg: function() {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/随堂测试/A选择框.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/随堂测试/A选择框.png');
                default: return require('@/assets/强国之路界面设计/随堂测试/A选择框.png');
            }
        },
        /** 随堂测试资源：【下一题】、【跳过】两个按钮的style */
        userAnsButtonsContainerStyle: function(bLand) {
            switch (this.code) {
                case 'english': return {fontSize:(bLand?'1.3vw':'2vh')};
                case 'math': return {fontSize:(bLand?'1.3vw':'2vh')};
                default: return {fontSize:(bLand?'1.3vw':'2vh')};
            }
        },
        /** 随堂测试资源：统计按钮【好的】style */
        userAnsStatButtonStyle: function() {
            switch (this.code) {
                case 'english': return {backgroundImage: `url(${require('@/assets/英语界面设计02/系统界面/随堂测试/好的.png')})`};
                default: return {};
            }
        },


        /** 课程摘要资源：容器style */
        summaryContainerStyle: function () {
            switch (this.code) {
                case 'english': return {color:'#000000'};
                case 'math': return {color:'#000000'};
                default: return {color:'#eeeeee'};
            }
        },
        /** 课程摘要资源：打开/关闭按钮图 */
        summarySwitchButtonImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/章节摘要/课程摘要.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/章节摘要/课程摘要.png');
                default: return require('@/assets/强国之路界面设计/章节摘要/课程摘要.png');
            }
        },
        /** 课程摘要资源：文本框背景图 */
        summaryTextContainerBgImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/章节摘要/摘要-文字框.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/章节摘要/摘要-文字框.png');
                default: return require('@/assets/强国之路界面设计/章节摘要/摘要-文字框.png');
            }
        },
        /** 课程摘要资源：四个标签页的图标和选中图标 */
        summaryTabs: function () {
            switch(this.code) {
                case 'english': return [
                    {id: 'zhaiyao', label: '摘要', icon0: require('@/assets/英语界面设计02/系统界面/章节摘要/摘要.png'), icon1: require('@/assets/英语界面设计02/系统界面/章节摘要/摘要点击.png') },
                    {id: 'gainian', label: '概念', icon0: require('@/assets/英语界面设计02/系统界面/章节摘要/概念.png'), icon1: require('@/assets/英语界面设计02/系统界面/章节摘要/概念点击.png') },
                    {id: 'wenti'  , label: '问题', icon0: require('@/assets/英语界面设计02/系统界面/章节摘要/问题.png'), icon1: require('@/assets/英语界面设计02/系统界面/章节摘要/问题点击.png')   },
                    {id: 'kuozhan', label: '扩展', icon0: require('@/assets/英语界面设计02/系统界面/章节摘要/扩展.png'), icon1: require('@/assets/英语界面设计02/系统界面/章节摘要/扩展点击.png') },
                ];
                case 'math': return [
                    {id: 'zhaiyao', label: '摘要', icon0: require('@/assets/数学课UI-0901/系统界面/章节摘要/摘要.png'), icon1: require('@/assets/数学课UI-0901/系统界面/章节摘要/摘要点击.png') },
                    {id: 'gainian', label: '概念', icon0: require('@/assets/数学课UI-0901/系统界面/章节摘要/概念.png'), icon1: require('@/assets/数学课UI-0901/系统界面/章节摘要/概念点击.png') },
                    {id: 'wenti'  , label: '问题', icon0: require('@/assets/数学课UI-0901/系统界面/章节摘要/问题.png'), icon1: require('@/assets/数学课UI-0901/系统界面/章节摘要/问题点击.png')   },
                    {id: 'kuozhan', label: '扩展', icon0: require('@/assets/数学课UI-0901/系统界面/章节摘要/扩展.png'), icon1: require('@/assets/数学课UI-0901/系统界面/章节摘要/扩展点击.png') },
                ];
                default: return [
                    {id: 'zhaiyao', label: '摘要', icon0: require('@/assets/强国之路界面设计/章节摘要/摘要.png'), icon1: require('@/assets/强国之路界面设计/章节摘要/摘要点击.png') },
                    {id: 'gainian', label: '概念', icon0: require('@/assets/强国之路界面设计/章节摘要/概念.png'), icon1: require('@/assets/强国之路界面设计/章节摘要/概念点击.png') },
                    {id: 'wenti'  , label: '问题', icon0: require('@/assets/强国之路界面设计/章节摘要/问题.png'), icon1: require('@/assets/强国之路界面设计/章节摘要/问题点击.png')   },
                    {id: 'kuozhan', label: '扩展', icon0: require('@/assets/强国之路界面设计/章节摘要/扩展.png'), icon1: require('@/assets/强国之路界面设计/章节摘要/扩展点击.png') },
                ];
            }
        },



        /** 老师提问资源：文字颜色style */
        teacherAskTextStyleColor: function () {
            switch (this.code) {
                case 'english': return {color:'#000000'};
                case 'math': return {color:'#000000'};
                default: return {color:'#eeeeee'};
            }
        },
        /** 老师提问资源：学生输入框背景图 */
        teacherAskInputBoxBgImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/教师提问页面/回答框.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/教师提问页面/回答框.png');
                default: return require('@/assets/强国之路界面设计/提问页面/回答框.png');
            }
        },
        /** 老师提问资源：语音自动确认勾选框-已勾选 */
        teacherAskAutoVoiceImgChecked: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/教师提问页面/语音自动确认-选中.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/教师提问页面/语音自动确认-选中.png');
                default: return require('@/assets/强国之路界面设计/提问页面/语音自动确认-选中.png');
            }
        },
        /** 老师提问资源：语音自动确认勾选框-未勾选 */
        teacherAskAutoVoiceImgUnchecked: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/教师提问页面/语音自动确认.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/教师提问页面/语音自动确认.png');
                default: return require('@/assets/强国之路界面设计/提问页面/语音自动确认.png');
            }
        },
        /** 老师提问资源：AI同学输入框背景图 */
        teacherAskAiMateInputBoxBgImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/教师提问页面/回答框.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/教师提问页面/回答框.png');
                default: return require('@/assets/强国之路界面设计/AI机器人讲话/讲话框.png');
            }
        },
        /** 老师提问资源：倒计时小时钟gif图 */
        teacherAskCountDownClockGifImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/teacher-asking/倒计时.gif');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/教师提问页面/倒计时动图.gif');
                default: return require('@/assets/teacher-asking/倒计时.gif');
            }
        },


        /** 进入场景资源：对话框文本颜色 */
        nextSceneContainerStyleColor: function () {
            switch (this.code) {
                case 'english': return '#000000';
                case 'math': return '#000000';
                default: return '#eeeeee';
            }
        },
        /** 进入场景资源：对话框背景图 */
        nextSceneContainerBgImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/进入场景/背景框.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/进入场景/背景框.png');
                default: return require('@/assets/强国之路界面设计/进入场景/背景框.png');
            }
        },
        /** 进入场景资源：进入按钮图 */
        nextSceneEnterButtonImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/进入场景/进入.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/进入场景/进入.png');
                default: return require('@/assets/强国之路界面设计/进入场景/进入.png');
            }
        },
        /** 进入场景资源：跳过按钮图 */
        nextSceneSkipButtonImg: function () {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/进入场景/跳过.png');
                case 'math': return require('@/assets/数学课UI-0901/系统界面/进入场景/跳过.png');
                default: return require('@/assets/强国之路界面设计/进入场景/跳过.png');
            }
        },


        /** 口语判分的资源：黑板框背景图 */
        oralScoringContainerImg: function() {
            switch (this.code) {
                case 'english': return require('@/assets/英语界面设计02/系统界面/口语判分/黑板框.png');
                default: return require('@/assets/强国之路界面设计/随堂测试/黑板框.png');
            }
        },
        oralScoringQuesTextBgImg: function () {
            return require('@/assets/英语界面设计02/系统界面/口语判分/识别文字底框.png');
        },
        oralScoringMicBeforeImg: function () {
            return require('@/assets/英语界面设计02/系统界面/口语判分/点击前的麦克风.png');
        },
        oralScoringMicRunningImg: function () {
            return require('@/assets/英语界面设计02/系统界面/口语判分/麦克风动图.gif');
        },
        oralScoringMicAfterImg: function () {
            return require('@/assets/英语界面设计02/系统界面/口语判分/点击后的麦克风.png');
        },

        /** 资源下载提示的样式 */
        resourceLoadingStyle: function(bLand) {
            const baseStyle = {
                position: 'absolute',
                display: 'flex',
                //width: bLand ? '40%' : '80%',
                height: bLand ? '15%' : '10%',
                fontSize: bLand ? '18px' : '4vw',
                border: '2px solid #e0e0e0',
                zIndex: 999,
                justifyContent: 'center',
                alignItems: 'center'
            };
            
            switch (this.code) {
                case 'chinese':
                    return {
                        ...baseStyle,
                        background: 'transparent',
                        color: '#876139',
                        fontSize: '25px',
                        fontWeight: 'bold',
                        border: 'none'
                    };
                default:
                    return {
                        ...baseStyle,
                        background: '#efefef',
                        color: '#121212'
                    };
            }
        },
    }
}
